import { useState } from 'react'
import {FormItemProps, Input, InputProps, Space} from 'antd'
import {FileInterface} from 'common/types'
import {
  // Text, 
  // IconButton, DotsIcon,
  Box, Button, 
  Form, FormItem, 
  UserPhoto, // UserAvatar,
} from 'common/components'
import {FIELD_RULES, EMAIL_FIELD_RULES} from 'common/constants'
import {useCreateNewUser, useUserUpdate, UserBase} from '..'

const DEFAULT_IMAGES = [1,2,3,4,5,6,7,8].map((n:number) => ( `https://pcnz-testing-api.s3.ap-southeast-2.amazonaws.com/avatar/${n}.png` ))
interface UserFormProps {
  initialValues?: any
  onClose: () => void
}

const Field = ({name, type, disabled, ...props}: FormItemProps & InputProps) => (
  <FormItem
    {...props}
    name={name}
    rules={type === 'email' ? EMAIL_FIELD_RULES : FIELD_RULES}
  >
    <Input
      autoFocus={name === 'firstName'}
      type={type}
      addonBefore={name === 'phone' ? '+64' : undefined}
      disabled={disabled}
    />
  </FormItem>
)

export default function UserForm({onClose, initialValues}: UserFormProps) {
  const [dfIdx] = useState<number>(Math.floor(Math.random() * (DEFAULT_IMAGES.length)))
  const [image, setImage] = useState<FileInterface>({})
  const {mutate: createNewUser, isMutating:isCreating} = useCreateNewUser( onClose )
  const {mutate: updateUser, isMutating:isUpdating} = useUserUpdate(initialValues?.uuid, onClose )
  const isMutating = isCreating || isUpdating

  const defaultAvatarLink = initialValues?.photo || DEFAULT_IMAGES[dfIdx]
  const currentImage = !!image?.url ? image : { url: defaultAvatarLink }

  const handleFinish = (values: UserBase) => {
    const newUser = {
      ...values,
      phone: `+64${values.phone.trim()}`
    }
    if (!!image?.uuid) {
      newUser.photo = image.uuid
    } else if (
      (!initialValues?.photo) && 
      (!!defaultAvatarLink) 
    ) {
      newUser.photo = defaultAvatarLink
    }
    if (!initialValues?.uuid) {
      createNewUser(newUser)
    } else {
      // alert(JSON.stringify({
      //   ...newUser,
      //   id: initialValues.uuid
      // }))
      updateUser(newUser)
    }
  }

  if (!!initialValues?.phone) {
    initialValues.phone = initialValues.phone.trim().replace('+64', '')
  }
  // console.log(initialValues)

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <UserPhoto medium={true} image={currentImage} setImage={setImage} />
        {/* <UserAvatar size={120} src={
          initialValues.photo || defaultAvatarLink
        } alt={initialValues.firstName || 'avatar'} /> */}
        {/* <IconButton
          className={'DotsMenu-Button_light'}
          icon={<DotsIcon />}
          aria-label="avatar"
        /> */}
      </div>
      {/* <Field hidden name="role" /> */}
      <Space size={16}>
        <Field name="firstName" label="First name" />
        <Field name="lastName" label="Last name" />
      </Space>
      <Field name="email" label="Email" type="email" disabled={!!initialValues?.email} />
      <Field name="phone" label="Phone number" />
      <div style={{height: '32px'}}></div>
      {/* <Text align="center" size="xs" mt={32} mb={24}>
        This borrower is registered. A password to log in to the application
        will be sent to his email. And detailed instructions.
      </Text> */}
      <Box mt={12}>
        <Button block htmlType="submit" loading={isMutating}>
          { !initialValues ? 
            'Invite via email' : 
            'Save' 
          }
        </Button>
      </Box>
    </Form>
  )
}
